import { Customer } from "data/customer.data";
import { Column } from "data/table.data";
import { convertProgress, convertRegNumber } from "utils/converter";
import {
  DashboardAction,
  RenderLink,
  renderProgressBar,
  renderProgressText,
  twoLineColumn,
  진행상태와색상표기,
} from "utils/renderer";

type DashboardColIdType =
  | "incharge"
  | "name"
  | "cluster"
  | "subCluster"
  | "regNumber"
  | "progressbar"
  | "progress"
  | "confirm"
  | "action";

interface DashboardColumnData extends Column {
  id: DashboardColIdType;
}

export const DASHBOARD_COLS: DashboardColumnData[] = [
  {
    id: "incharge",
    label: "담당자",
    sorting: true,
    sx: { width: 72 },
  },
  {
    id: "name",
    label: "업체명",
    sorting: true,
    linkMaker: (data, addPath) =>
      RenderLink(`review/${addPath}`, data.id, data.name),
    sx: { width: 160, wordBreak: "break-all" },
  },
  {
    id: "cluster",
    label: "업종",
    sorting: true,
    sx: { width: 104 },
  },
  {
    id: "subCluster",
    label: "업태",
    sorting: true,
    sx: { width: 120, wordBreak: "break-all" },
  },
  {
    id: "regNumber",
    label: "사업자등록번호",
    renderer: (data) => convertRegNumber(data.regNumber),
    sx: { width: 144, whiteSpace: "nowrap" },
  },
  {
    id: "progressbar",
    label: 진행상태와색상표기(),
    renderer: (data) =>
      renderProgressBar(
        data.totalDataNumber,
        data.completedDataNumber,
        data.newzenTransferredDataNumber
      ),
    sx: { width: 200 },
  },
  // {
  //   id: "progress",
  //   label: twoLineColumn("작업량", "전송량"),
  //   renderer: (data) =>
  //     renderProgressText(
  //       data.totalDataNumber,
  //       data.totalDataNumber ? data.completedDataNumber : "-",
  //       data.totalDataNumber ? data.newzenTransferredDataNumber : "-"
  //     ),
  //   sx: { width: 96, textAlign: "right" },
  // },
  {
    id: "confirm",
    label: "마감",
    renderer: (data) => (data.isAccountingConfirmed ? "완료" : "미완료"),
    sx: { width: 32 },
  },
  {
    id: "action",
    label: "다운로드",
    renderer: (data) => DashboardAction(data),
    sx: { width: 48, textAlign: "center" },
  },
];

export const CUSTOMER_SAMPLE_DATA: Customer[] = [
  {
    id: "1",
    bizNum: "123-45-67890",
    industryType: "서비스",
    businessType: "컨설팅",
    name: "지에이치케이 컨설팅",
    email: "a@a.com",
    guideLine: "가이드라인",

    taxFirm: "세무사",
    worker: "아무개",
    insertedAt: "2021-09-01",
    updatedAt: "2021-09-01",
    deleted: false,

    doneTransaction: 240,
    totalTransaction: 250,
    isDone: false,
  },
  {
    id: "2",
    bizNum: "234-56-78901",
    industryType: "제조",
    businessType: "가공",
    name: "에이치에스케이 가공",
    email: "b@b.com",
    guideLine: "가이드라인",

    taxFirm: "세무사",
    worker: "아무개",
    insertedAt: "2021-09-01",
    updatedAt: "2021-09-01",
    deleted: false,

    doneTransaction: 240,
    totalTransaction: 250,
    isDone: false,
  },
];
